const FONT_AWESOME_HREF =
	'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
const FONT_AWESOME_INTEGRITY =
	'sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA==';

let fontAwesomeStylesPromise: Promise<void> | null = null;

export const ensureFontAwesomeStyles = (): Promise<void> => {
	if (fontAwesomeStylesPromise) return fontAwesomeStylesPromise;

	fontAwesomeStylesPromise = new Promise<void>((resolve) => {
		const existing = document.querySelector<HTMLLinkElement>(
			'link[data-app-icon-font="font-awesome"]'
		);
		if (existing?.sheet) {
			resolve();
			return;
		}

		const link = existing ?? document.createElement('link');
		link.dataset.appIconFont = 'font-awesome';
		link.rel = 'stylesheet';
		link.href = FONT_AWESOME_HREF;
		link.integrity = FONT_AWESOME_INTEGRITY;
		link.crossOrigin = 'anonymous';
		link.referrerPolicy = 'no-referrer';
		link.addEventListener('load', () => resolve(), { once: true });
		link.addEventListener(
			'error',
			() => {
				fontAwesomeStylesPromise = null;
				resolve();
			},
			{ once: true }
		);

		if (!existing) document.head.appendChild(link);
	});

	return fontAwesomeStylesPromise;
};
